<template>
  <div class="bg-white shadow rounded sm:rounded-lg p-4 sm:p-6 max-w-md mx-auto text-center mt-4 sm:mt-8 md:mt-12">
    <img src="/assets/images/mail.png" class="inline-block mb-4" />
    <div class="text-center">
      <h4 class="leading-relaxed text-gray-800 text-base sm:text-xl sm:leading-8 font-bold mb-2">
        We emailed a 6 digit verification code to {{ user.email }}
      </h4>
      <div class="flex gap-1 items-center justify-center mb-4 text-sm">
        <p>Wrong Email?</p>
        <button class="cursor-pointer Change it text-indigo-700 underline" @click="wrongEmailButtonHandler()">Change it</button>
      </div>
      <p class="text-sm sm:text-base text-gray-500 font-medium mb-4">Enter 6 digit verification code:</p>

      <div>
        <div>
          <v-the-mask mask="######" type="text" name="email_verification_code" v-model="email_verification_code"
            :masked=false placeholder="Enter verification code"
            class="placeholder:text-sm mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"
            :class="{ 'border-red-500': errors.email_verification_code }">
          </v-the-mask>
          <span class="text-gray-500 text-xs">
            Did not get the email? Check spam or click Resend.
          </span>
        </div>

        <div class="text-red-600 text-sm py-3 text-left" v-if="errors.email_verification_code">
          <i class="fa fa-exclamation-triangle"></i> {{ errors.email_verification_code }}
        </div>
      </div>

      <button type="button" @click="verify()"
        class="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm sm:text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mt-4 sm:mt-6">
        Verify and continue
      </button>

      <div class="mt-3 sm:mt-4">
        <a href="javascript:void(0);" @click="resendVerificationEmail"
          class="text-sm sm:text-base font-medium text-indigo-600 underline">
          Resend verification code
        </a>
      </div>

      <div v-if="resendEmailSuccessMessage" class="mt-3">
        <p class="text-xs font-medium text-green-600">{{ resendEmailSuccessMessage }}</p>
      </div>

      <div v-if="resendEmailManyAttempts" class="mt-3">
        <p class="text-xs font-medium text-red-600">{{ resendEmailManyAttempts }}</p>
      </div>
      
    </div>
  </div>
</template>

<script>
import UserApi from "@/services/api/User.js";
import { helpers } from "@/mixins/helpers.js";
export default {
  props: ["accountNumber", "property", "user"],
  mixins: [helpers],
  data() {
    return {
      data: {},
      errors: {},
      resendEmailSuccessMessage: null,
      email_verification_code: null,
      resendEmailManyAttempts: null,
    };
  },
  methods: {
    wrongEmailButtonHandler() {
      window.blockUI();
      UserApi.wrongEmail(this.accountNumber)
        .then((res) => {
          window.unblockUI();
          if (res.data.error) {
            setTimeout(
              flash(res.data.message, "error"),
              3000
            );
          }
          window.location.href = res.data.redirectUrl;
        })
        .finally(() => {
          window.unblockUI();
        });
    },
    resendVerificationEmail() {
      window.blockUI();
      this.resendEmailManyAttempts = null;
      UserApi.resendVerificationEmail(this.accountNumber)
        .then((res) => {
          window.unblockUI();
          this.resendEmailSuccessMessage =
            "Email verification code has been sent";
        })
        .catch((error) => {
          // Handle errors, including rate-limiting
          if (error.response) {
            // Backend returned a response (JSON) with status code
            if (error.response.status === 429) {
              // Rate limit exceeded
              this.resendEmailSuccessMessage = null;
              this.resendEmailManyAttempts = error.response.data.message;
            }
          }
        })
        .finally(() => {
          window.unblockUI();
        });
    },
    validateData() {
      var errors = {};

      let error = false;

      if (!this.email_verification_code) {
        errors.email_verification_code =
          "Please enter valid email verification code";
        error = true;
      }

      if (
        this.email_verification_code &&
        this.email_verification_code.length < 6
      ) {
        errors.email_verification_code =
          "Email verification code must be of 6 digits";
        error = true;
      }

      this.errors = errors;

      return error;
    },
    verify() {
      if (this.validateData()) return;

      UserApi.verifyEmail(
        this.user.email,
        this.email_verification_code,
        this.accountNumber
      )
        .then((res) => {
          window.unblockUI();

          if (!res.data.error) {
            setTimeout(
              flash("Your email ID has been verified", "success"),
              3000
            );
            window.location.href = res.data.redirectUrl;
          } else {
            var errors = {};
            errors.email_verification_code = res.data.message;
            this.errors = errors;
          }
        })
        .finally(() => {
          window.unblockUI();
        });
    },
  },
};
</script>
